import React, { useContext, useEffect, useState } from 'react';
import { Tooltip, OverlayTrigger, Modal } from 'react-bootstrap';
import LoadinSpin from '../ui/LoadinSpin';
import { TblHAnunciosUS, headTbl } from '../../data/tables';
import { useGetDta } from '../../hooks/useGetDta';
import { useShowColums, useShowColumsHook } from '../../hooks/useShowColums';
import moment from 'moment';
import Confirmation from '../ui/Confirmation';
import Table from '../Table';
import DropDownsCol from '../ui/DropDownsCol';
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';
import { getInitialColumns } from '../../data/cards';
import { AuthContext } from '../../auth/AuthContext';
import { checkAccess } from '../../helpers/details';
const baseUrl = process.env.REACT_APP_API;

const TblAnunciosUs = ({ tab, eliminar = true }) => {
    const { loading, data, getInfo } = useGetDta(`proxy/users`);

    const initialColums = getInitialColumns('users', TblHAnunciosUS);
    const { toggleCheck, columnasVisibles } = useShowColumsHook(initialColums, 'users');

    const [showd, setShowd] = useState(false);
    const [info, setInfo] = useState({});
    const [zoom, setZoom] = useState();
    const [modal, setModal] = useState(false);

    useEffect(() => {
        getInfo();
    }, [tab]);

    if (loading) return <LoadinSpin />;
    const showImg = (url) => {
        setZoom(url);
        setModal(true);
    };

    const ActionColumn = ({ row }) => {
        return (
            <>
                <OverlayTrigger placement="left" overlay={<Tooltip id="overlay-example">Borrar</Tooltip>}>
                    <i className="mdi mdi-delete mdi-18px " onClick={() => dele(row.original.ids)}></i>
                </OverlayTrigger>
            </>
        );
    };
    const Imagen = ({ row }) => {
        return (
            <>
                <img
                    src={baseUrl + row.original.foto}
                    alt="FOTO"
                    width={'50px'}
                    onClick={() => showImg(row.original.foto)}
                />
            </>
        );
    };
    const fechaCell = ({ row }) => {
        return (
            <>
                {moment(
                    `${row.original.now === 1 ? row.original.createdAt : `${row.original.fecha} ${row.original.hora}`}`
                ).format('YYYY-MM-DD HH:mm:ss')}{' '}
            </>
        );
    };
    const StateCell = ({ row }) => {
        return (
            <span
                className={classNames('badge', {
                    'bg-success': row.original.estate === 'ENVIADO',
                    'bg-info': row.original.estate === 'PENDIENTE',
                    'bg-danger': row.original.estate === 'MOROSO',
                })}>
                {row.original.estate}
            </span>
        );
    };
    const IpCell = ({ row }) => {
        return (
            <div className="r">
                {row.original.emit}
                <span className={classNames('badge bg-info mx-2')}>{row.original.ipe}</span>
            </div>
        );
    };
    const NameCell = ({ row }) => {
        return (
            <NavLink to={`/admin/viewuser/${btoa(`${row.original.idu}`)}`} className="pointer">
                {row.original.nombre}
            </NavLink>
        );
    };
    const TipoCell = ({ row }) => {
        return <span className="badge bg-info ">{row.original.type}</span>;
    };

    const columns = [
        {
            Header: 'Tipo',
            accessor: 'type',
            sort: true,
            Cell: TipoCell,
        },
        {
            Header: 'Imagen',
            accessor: 'foto',
            sort: true,
            Cell: Imagen,
        },
        {
            Header: 'Nombre',
            accessor: 'nombre',
            sort: true,
            Cell: NameCell,
        },
        {
            Header: 'Descripción',
            accessor: 'descripcion',
            sort: true,
        },

        {
            Header: 'Emitido por ',
            accessor: 'ipe',
            sort: true,
            // Cell: IpCell,
        },

        {
            Header: 'Fecha de emisión',
            accessor: 'fecha',
            sort: true,
            Cell: fechaCell,
        },
        {
            Header: 'Estado',
            accessor: 'estate',
            sort: true,
            Cell: StateCell,
        },

        {
            Header: 'Acción',
            accessor: 'action',
            sort: false,
            classes: 'table-action',
            Cell: ActionColumn,
        },
    ];
    const sizePerPageList = headTbl(data.length);
    const dele = (id, idus) => {
        setInfo({ id, type: 'SCREEN-USUARIO' });
        setShowd(true);
    };
    return (
        <div>
            <Confirmation show={showd} toggle={() => setShowd(false)} info={info} callBk={getInfo} />

            <Table
                columns={columns}
                data={data}
                pageSize={25}
                sizePerPageList={sizePerPageList}
                isSortable={true}
                pagination={true}
                isSearchable={true}
                columnasVisibles={columnasVisibles}
                theadClass="table-light"
                searchBoxClass="mb-2"
                visiblesCustum={
                    <DropDownsCol
                        cols={columnasVisibles} // Pasar el estado desde TblZonas
                        toggleCheck={toggleCheck} // Pasar la función de toggleCheck desde TblZonas
                    />
                }
            />
            <Modal size="lg" centered show={modal} onHide={() => setModal(false)}>
                <img src={baseUrl + `${zoom}`} alt="ANUNCIO" width={'100%'} />
            </Modal>
        </div>
    );
};

export default TblAnunciosUs;
